// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_g7-7";
export var emphasizeQuantity = "_g7-3";
export var flatBottomCorners = "_g7-5";
export var productImage = "_g7-0";
export var quantityContainer = "_g7-2";
export var quantityHeader = "_g7-6";
export var tooltip = "_g7-1";
export var wrapAndEllipsesOverflow = "_g7-4";